import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';
/**
 * タグ一括設定画面の値を管理するクラス
 *
 * @export KYMW4602Model
 * @class KYMW4602Model
 */
export class KYMW4602Model {
  // タグ情報
  public tagId = '';
  public tagName = '';

  // Pコード
  public PCodes = '';
  // 登録成功Pコード
  public registedPCodes: string[] = [];

  /**
   * 行数
   *
   * @memberof KYMW4602Model
   */
  get counter(): number {
    return this.PCodes.split(/\n/).filter(_ => _.length > 0).length;
  }

  /**
   * 無効行
   *
   * @memberof KYMW4602Model
   */
  get invalidLines(): string[] {
    return this.PCodes.split(/\n/)
      .filter(_ => _.length > 0)
      .filter(_ => !PlessViewUtilsSub.PCODE_REGEX.test(_));
  }

  /**
   * 有効行
   *
   * @memberof KYMW4602Model
   */
  get validLines(): string[] {
    return this.PCodes.split(/\n/)
      .filter(_ => _.length > 0)
      .filter(_ => PlessViewUtilsSub.PCODE_REGEX.test(_));
  }

  /**
   * 失敗行
   *
   * @memberof KYMW4602Model
   */
  get failLines(): string[] {
    return this.PCodes.split(/\n/)
      .filter(_ => _.length > 0)
      .filter(_ => PlessViewUtilsSub.PCODE_REGEX.test(_))
      .filter(_ => !this.registedPCodes.includes(_));
  }
}
